import React, { useEffect } from 'react';
import { Path, Controller, useWatch, useFormContext } from 'react-hook-form';
import { TextField } from '@mui/material';
import { ReviewFormValues, OTHER_SENTINEL, OTHER_MAX } from '../types';

interface SomethingElseFieldProps {
    name: Path<ReviewFormValues>;
    dependsOn: Path<ReviewFormValues>;
    label: string;
}

const SomethingElseField: React.FC<SomethingElseFieldProps> = ({
    name,
    dependsOn,
    label,
}) => {
    const { control, setValue } = useFormContext<ReviewFormValues>();
    const selected: string[] = useWatch({ name: dependsOn, control }) ?? [];
    const visible = selected.includes(OTHER_SENTINEL);

    useEffect(() => {
        if (!visible)
            setValue(name, '', { shouldDirty: true, shouldValidate: true });
    }, [visible, name, setValue]);

    if (!visible) return null;

    return (
        <Controller
            key={name as string}
            name={name}
            control={control}
            render={({ field, fieldState }) => {
                const currentLength = field.value?.length || 0;
                return (
                    <TextField
                        {...field}
                        label={label}
                        placeholder='Add a short note (max 200 chars)'
                        fullWidth
                        multiline
                        minRows={2}
                        inputProps={{ maxLength: OTHER_MAX }}
                        error={!!fieldState.error}
                        helperText={
                            fieldState.error?.message ||
                            `${currentLength}/${OTHER_MAX} characters`
                        }
                        sx={{ mt: 1.5 }}
                    />
                );
            }}
        />
    );
};

export default SomethingElseField;
